/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShipId
 */
export interface ShipId {
    /**
     * 
     * @type {number}
     * @memberof ShipId
     */
    mmsi?: number;
}

/**
 * Check if a given object implements the ShipId interface.
 */
export function instanceOfShipId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipIdFromJSON(json: any): ShipId {
    return ShipIdFromJSONTyped(json, false);
}

export function ShipIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
    };
}

export function ShipIdToJSON(value?: ShipId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mmsi': value.mmsi,
    };
}

